import { Component } from '@angular/core'

@Component({
  selector: 'papi-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {}
